/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Status_ActiveInputs */

const en_team_status_active = /** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const es_team_status_active = /** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const fr_team_status_active = /** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const de_team_status_active = /** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const id_team_status_active = /** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const ja_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const zh_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const ar_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const it_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const ru_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const pt_team_status_active = en_team_status_active;

/** @type {(inputs: Team_Status_ActiveInputs) => LocalizedString} */
const ko_team_status_active = en_team_status_active;

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Team_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_status_active = /** @type {((inputs?: Team_Status_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Status_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_status_active(inputs)
	if (locale === "es") return es_team_status_active(inputs)
	if (locale === "fr") return fr_team_status_active(inputs)
	if (locale === "de") return de_team_status_active(inputs)
	if (locale === "ja") return ja_team_status_active(inputs)
	if (locale === "zh") return zh_team_status_active(inputs)
	if (locale === "ar") return ar_team_status_active(inputs)
	if (locale === "id") return id_team_status_active(inputs)
	if (locale === "it") return it_team_status_active(inputs)
	if (locale === "ru") return ru_team_status_active(inputs)
	if (locale === "pt") return pt_team_status_active(inputs)
	return ko_team_status_active(inputs)
});